import { ActionCreator } from '@sendoutcards/core'
import { InviteFragment } from 'src/graphql/fragments/__generated__/InviteFragment'

export const createdInvite = ActionCreator(
  'CREATED_INVITE',
  (invite: InviteFragment) => ({ invite }),
)

export const creatingInvite = ActionCreator('CREATING_INVITE')
